var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E1E7EA",
    d: "M24 13.867C24 15.04 22.971 16 21.714 16H2.286C1.029 16 0 15.04 0 13.867V2.133C0 .96 1.029 0 2.286 0h19.428C22.971 0 24 .96 24 2.133v11.734z",
    transform: "translate(-916 -1481) translate(81 1463) translate(835 18) translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF6D00",
    d: "M24 13.867C24 15.04 22.971 16 21.714 16H7.43S20.914 13.973 24 8v5.867zM10.857 8c0 .907.743 1.6 1.714 1.6.972 0 1.715-.693 1.715-1.6 0-.907-.743-1.6-1.715-1.6-.971 0-1.714.693-1.714 1.6z",
    transform: "translate(-916 -1481) translate(81 1463) translate(835 18) translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M4.686 6.4h.628v3.2h-.628V6.4zM8.114 8c0 .907.743 1.6 1.715 1.6.285 0 .514-.053.8-.16v-.693c-.229.213-.458.32-.8.32C9.2 9.067 8.743 8.64 8.743 8c0-.587.457-1.067 1.086-1.067.285 0 .514.107.8.32V6.56c-.286-.107-.515-.213-.8-.213-.972.053-1.715.8-1.715 1.653zm7.657.48l-.914-2.08h-.686L15.6 9.6h.343l1.428-3.2h-.685l-.915 2.08zm1.886 1.12h1.829v-.533h-1.2v-.854h1.143V7.68h-1.143v-.747h1.2V6.4h-1.829v3.2zM22 7.36c0-.587-.4-.96-1.143-.96h-.971v3.2h.628V8.32h.057l.915 1.28h.8l-1.029-1.333c.457-.107.743-.427.743-.907zm-1.314.533h-.172v-.96h.172c.4 0 .628.16.628.48 0 .267-.171.48-.628.48zm-18-1.493h-.972v3.2h.915C4.057 9.6 4.4 8.48 4.4 8c.057-.96-.686-1.6-1.714-1.6zm-.172 2.667h-.171V6.933h.228c.858 0 1.2.534 1.2 1.067 0 .213-.057 1.067-1.257 1.067zm4.515-1.44c-.4-.16-.515-.214-.515-.374 0-.213.229-.32.457-.32.172 0 .343.054.515.267l.343-.427c-.286-.266-.572-.373-.972-.373-.571 0-1.028.373-1.028.907 0 .426.228.64.8.853.342.107.628.213.628.48s-.228.427-.514.427c-.286 0-.572-.16-.686-.427l-.4.373c.286.427.629.587 1.143.587.686 0 1.143-.427 1.143-1.013 0-.48-.229-.694-.914-.96z",
    transform: "translate(-916 -1481) translate(81 1463) translate(835 18) translate(0 4)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.04c123d62c0b44922be70f5d048bd09e.svg";
export { ForwardRef as ReactComponent };